import React from 'react';
import Text from "@amzn/meridian/text"
import Box from "@amzn/meridian/box"
import Column from "@amzn/meridian/column"
import './Sidebar.css';

const Sidebar: React.FC = () => {
  return (
  <Box spacingInset="400" width={250} backgroundColor="subdued" height="100%" className="sidebar-container">
    <Column spacing="300" height="100%">
      <Box>
        <Box spacingInset="none none 200 none">
          <Text type="h400">About This App</Text>
        </Box>
        <Text type="b200">
          GFT Ordis is an AI-powered assistant designed to help you with various
           operations tasks like:
        </Text>
        <ul className="sidebar-list">
          <li><Text type="b200">TM1 Instance Management</Text></li>
          <li><Text type="b200">Backup Operations</Text></li>
        </ul>
        <Text type="b200">
          Simply type your message in the input box below and
          Ordis will respond with helpful information.
        </Text>
      </Box>
    </Column>
  </Box>
  );
};

export default Sidebar;
